import { Category } from "./Categories";

export default Category;